import React from 'react'

export default function Container({ children, bodyBgColor }) {
    return (
        <div className="app" style={{ backgroundColor: bodyBgColor }}>
            <div className="container">
                {children}
            </div>
        </div>
    )
}
